import { KFM_WEB_AUTH_CONFIG_KEY } from '@shared/constants/constants';
import { Environment } from './environment.model';
import { AppStage } from '@shared/enums/app-state.enum';

export const baseEnvironment: Environment = {
  appStage: AppStage.local,
  appVersion: '1.4.0',
  auth: {
    configId: KFM_WEB_AUTH_CONFIG_KEY,
    clientId: 'kaufmann_web_client',
    authority: 'https://auth-service-dev.hottgenroth.de',
    scopes:
      'openid offline_access profile email kaufmann_web_service_scp ' +
      'contact_service_scp LicenseService info_banner_scp project_service_scp ' +
      'booking_service_scp',
  },
  chatBotUrl:
    'https://aichatbot-ui-copilot-web-dev-ntpaja4wua23a.azurewebsites.net/chat',
};

export const environment = baseEnvironment;
